import { type JSX } from 'react';
import { IconBase, type IconProps } from '@doxyme/icons';

export const Yahoo = (props: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 44 44' width={44} height={44} {...props}>
    <g clip-path='url(#clip0_18117_29861)'>
      <path
        d='M37.4 0H6.6C2.95492 0 0 2.95492 0 6.6V37.4C0 41.0451 2.95492 44 6.6 44H37.4C41.0451 44 44 41.0451 44 37.4V6.6C44 2.95492 41.0451 0 37.4 0Z'
        fill='#5F01D1'
      />
      <path
        d='M17.4453 34.7186H12.1172L14.2656 29.6483L8.33594 15.4686H13.75L16.9297 23.6327L20.1094 15.4686H25.4375M30.4219 21.9999H24.4922L29.8203 9.28113H35.75'
        fill='white'
      />
      <path
        d='M26.0391 29.7341C27.8426 29.7341 29.3047 28.2721 29.3047 26.4685C29.3047 24.665 27.8426 23.2029 26.0391 23.2029C24.2355 23.2029 22.7734 24.665 22.7734 26.4685C22.7734 28.2721 24.2355 29.7341 26.0391 29.7341Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_18117_29861'>
        <rect width='44' height='44' fill='white' />
      </clipPath>
    </defs>
  </IconBase>
);
